const STORAGE_KEY = 'v3me:last-seen-changelog-version';

export const releases = [
  {
    version: 'v3.9.0',
    date: 'August 6, 2026',
    title: 'Workout Planning',
    summary: 'Schedule a workout template for a future day without starting the workout, then keep planned sessions visible where they are useful.',
    videoUrl: '/changelog/videos/workout-planning.mp4?v=3.9.0-workout-planning',
    poster: null,
    highlights: [
      'Choose a future calendar day and add a workout from one of your templates.',
      'See planned workouts on the calendar before it is time to train.',
      'Keep future workouts hidden from workout history by default.',
      'Turn on Show planned workouts whenever you want to review upcoming sessions in the workout list.',
    ],
  },
  {
    version: 'v3.8.0',
    date: 'July 30, 2026',
    title: 'Personal API Keys',
    summary: 'Connect personal integrations, scripts, and agents to your V3ME account with revocable API keys and public developer documentation.',
    videoUrl: null,
    poster: null,
    highlights: [
      'Create and name personal API keys from your Profile.',
      'Copy a new key from a secure one-time confirmation window.',
      'Review and revoke existing keys whenever access is no longer needed.',
      'Use the public API documentation for core training and tracking resources.',
    ],
  },
  {
    version: 'v3.7.0',
    date: 'July 30, 2026',
    title: 'Workout Circuits',
    summary: 'Build reusable multi-round circuits with movements and rests organized in the right places.',
    videoUrl: null,
    poster: null,
    highlights: [
      'Group movements and rests into reusable multi-round circuits.',
      'Add, reorder, or remove movements and rests within a circuit.',
      'Keep recovery after a circuit separate from rests inside each round.',
      'Carry circuit structure from templates into workouts without changing standard workout items.',
    ],
  },
  {
    version: 'v3.6.0',
    date: 'July 17, 2026',
    title: 'Marketplace',
    summary: 'Discover community-built templates and movements, preview what each resource includes, and import useful training resources into your own account. Marketplace access is rolling out gradually, so it may not appear for everyone right away.',
    videoUrl: '/changelog/videos/marketplace.mp4?v=3.6.0-marketplace-feedback-black-outro-fade',
    poster: null,
    highlights: [
      'Publish custom movements and templates when they are ready to share.',
      'Import marketplace resources while preserving their original source.',
      'Template cards show included movements, rest timers, set counts, demo videos, ratings, views, and downloads.',
      'Rate imported resources so the best community resources can stand out.',
      'We are starting with a gradual rollout while we watch usage and feedback.',
    ],
  },
  {
    version: 'v3.5.0',
    date: 'July 8, 2026',
    title: 'Exercise Sets',
    summary: 'Group repeated work for the same movement into tidy sets while keeping the classic one-row workout layout available in settings.',
    videoUrl: '/changelog/videos/exercise-sets.mp4?v=3.5.0-exercise-sets',
    poster: null,
    highlights: [
      'Repeated movement entries are grouped under one movement header.',
      'Each set keeps its own bands, reps, exhaustion level, notes, and previous-rep context.',
      'Add or delete individual sets without rebuilding the whole movement.',
      'Users who prefer the classic layout can disable Sets in settings.',
    ],
  },
  {
    version: 'v3.4.0',
    date: 'July 2, 2026',
    title: 'Calendar Review',
    summary: 'Review your training history by day, so it is easier to find the workouts and log entries you are looking for.',
    videoUrl: '/changelog/videos/calendar-review.mp4?v=3.4.0-calendar-review',
    poster: null,
    highlights: [
      'Calendar days are shaded when they have logged activity.',
      'Tap any day to see the workouts and log entries saved for that date.',
      'Move between days without digging through one long workout list.',
      'Feature feedback is available directly from What’s New.',
    ],
  },
  {
    version: 'v3.3.0',
    date: 'June 29, 2026',
    title: 'Rest Timers',
    summary: 'Add rest timers to templates, adjust them during a workout, and let V3ME guide the next exercise when rest is complete.',
    videoUrl: '/changelog/videos/rest-timer.mp4?v=3.3.0-rest-timer-final-pass',
    poster: null,
    highlights: [
      'Rest timers can be enabled and configured in settings.',
      'Templates can include rest timers between movements.',
      'Workout timers support quick fifteen second adjustments.',
      'Optional automation can start timers and open the next exercise.',
    ],
  },
  {
    version: 'v3.2.34',
    date: 'June 28, 2026',
    title: 'Ideas, Votes, Surveys, and Bug Reports',
    summary: 'V3ME now collects product ideas, feature votes, survey ratings, and bug reports directly inside the app.',
    videoUrl: null,
    poster: null,
    highlights: [
      'Share Idea, Feature Feedback, Report Bug, and Send Feedback actions are available from the app menu.',
      'Users can vote on curated ideas without leaving V3ME.',
    ],
  },
  {
    version: 'v3.2.33',
    date: 'June 26, 2026',
    title: 'Previous Reps at a Glance',
    summary: 'Exercise rows now show previous full and partial rep counts before you open the editor, making it easier to compare your current set with recent history.',
    videoUrl: null,
    poster: null,
    highlights: [],
  },
  {
    version: 'v3.2.26',
    date: 'June 10, 2026',
    title: 'Cleaner Workout Drafts and Settings',
    summary: 'Untouched autosaved workout drafts are discarded instead of becoming empty completed workouts, and settings rows now use cleaner switches.',
    videoUrl: null,
    poster: null,
    highlights: [],
  },
  {
    version: 'v3.2.15',
    date: 'May 26, 2026',
    title: 'Better Max Reps History',
    summary: 'Max Reps history now works for selected bodyweight and non-band movements too, so more exercise types can show useful progress context.',
    videoUrl: null,
    poster: null,
    highlights: [],
  },
];

export const latestRelease = releases[0];

export function getLastSeenChangelogVersion() {
  return window.localStorage.getItem(STORAGE_KEY);
}

export function hasUnreadChangelogRelease() {
  return getLastSeenChangelogVersion() !== latestRelease.version;
}

export function markChangelogReleaseSeen(version = latestRelease.version) {
  window.localStorage.setItem(STORAGE_KEY, version);
  window.dispatchEvent(new CustomEvent('v3me:changelog-read-status-changed'));
}
